<script setup lang="ts">

const { getAgenda } = useHome()
const { data: events } = await useAsyncData('home-agenda-v3', () => getAgenda())

const getTypeColor = (type: string) => {
  switch (type) {
    case 'JPO': return 'text-oxo-red border-oxo-red'
    case 'Stage': return 'text-oxo-yellow border-oxo-yellow'
    default: return 'text-white border-white'
  }
}
</script>

<template>
  <section v-if="events && events.length > 0" id="agenda" class="py-section-py bg-background relative transition-colors duration-300">
    <!-- Background Pattern -->
    <div class="absolute inset-0 opacity-20"></div>
    
    <div class="container mx-auto px-container-px relative z-20">
      <div class="flex flex-col xl:flex-row justify-between xl:items-start mb-section-header-mb gap-8">
        
        <!-- Title (Clickable) -->
        <NuxtLink to="/actus#agenda" class="flex items-center gap-4 shrink-0 xl:self-start group cursor-pointer w-full xl:w-64">
          <div class="w-12 h-12 rounded-xl bg-oxo-red flex items-center justify-center text-white text-2xl shadow-[0_0_20px_rgba(227,6,19,0.4)] animate-pulse group-hover:scale-110 transition-transform duration-300">
            <i class="fas fa-calendar-alt" aria-hidden="true"></i>
          </div>
          <div>
            <h2 class="font-display font-black text-2xl text-foreground uppercase tracking-wide group-hover:text-oxo-red transition-colors">
              Agenda
            </h2>
            <p class="text-foreground-dim text-sm">Ne manquez pas nos prochains rendez-vous</p>
          </div>
        </NuxtLink>

        <!-- Events List -->
        <ul v-if="events" class="grow grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 w-full xl:w-auto list-none m-0 p-0">
          <li v-for="event in events" :key="event.id" class="w-full xl:max-w-none flex-none mx-auto xl:mx-0">
            <NuxtLink 
              :to="`/actus/evenement/${event.slug}`"
              class="block h-full"
            >
              <article class="group bg-oxo-card-bg/20 hover:bg-oxo-card-bg/40 border border-oxo-border rounded-xl p-4 transition-all duration-300 cursor-pointer flex items-center gap-4 h-full">
                <div class="flex flex-col items-center justify-center w-12 h-12 rounded-lg border-2 bg-background shrink-0" :class="getTypeColor(event.type)">
                  <i class="fas fa-arrow-right transform -rotate-45 group-hover:rotate-0 transition-transform duration-300" aria-hidden="true"></i>
                </div>
                <div class="min-w-0 grow">
                  <div class="flex flex-wrap items-center gap-x-2 gap-y-1 mb-1">
                    <span class="text-[10px] font-bold uppercase px-1.5 py-0.5 rounded-sm border whitespace-nowrap" :class="getTypeColor(event.type)">{{ event.type }}</span>
                    <time class="text-oxo-yellow font-bold text-xs whitespace-nowrap">
                      {{ event.date }}
                      <span v-if="event.endDateFormatted" class="opacity-80 font-normal"> - {{ event.endDateFormatted }}</span>
                    </time>
                  </div>
                  <h3 class="text-foreground text-sm font-bold leading-tight group-hover:text-foreground/80 transition-colors line-clamp-2 overflow-hidden">
                    {{ event.title }}
                  </h3>
                </div>
              </article>
            </NuxtLink>
          </li>
        </ul>

        <!-- CTA -->
        <div class="shrink-0 flex justify-center xl:justify-start xl:self-start mt-4 xl:mt-0">
          <AppButton to="/actus#agenda" variant="primary" size="lg" class="w-fit shadow-[0_0_20px_rgba(227,6,19,0.3)] hover:shadow-[0_0_30px_rgba(227,6,19,0.5)]">
            Voir tout l'agenda
          </AppButton>
        </div>

      </div>
    </div>
  </section>
</template>
